<template>
  <div v-if="usuario">
    <!-- SIDE NAV -->
    <v-navigation-drawer
      v-model="nav"
      app
      :temporary="isMobile"
      :mini-variant.sync="mini"
      width="320"
      class="side-drawer ios-float-drawer ficenca-nav"
      overlay-color="#000"
      :overlay-opacity="0.25"
      floating
    >
      <!-- Brand -->
      <div class="px-4 pt-4 pb-2 brand-panel">
        <v-img
          width="180"
          class="mx-auto my-2"
          src="@/assets/logo.png"
          alt="Ficenca"
          contain
        />
        <div class="brand-caption">SERVICIO Y MANTENIMIENTO</div>
      </div>

      <!-- User mini profile -->
      <v-list-item class="user-block">
        <v-list-item-avatar size="44">
          <img
            :src="usuario.pic || defaultAvatar"
            @error="onAvatarError"
            alt="avatar"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold text-truncate">
            {{ usuario.username || 'Usuario' }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-truncate">
            {{ usuario.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-chip x-small class="role-chip" outlined>{{ usuario.cargo || '—' }}</v-chip>
      </v-list-item>

      <!-- Search -->
      <div class="px-4 pb-2">
        <div class="search">
          <i class="fas fa-search search-icon"></i>
          <input
            v-model.trim="q"
            class="search-input"
            type="text"
            placeholder="Buscar en menú…"
          />
        </div>
      </div>

      <!-- Main Menu -->
      <v-list dense shaped class="py-0">
        <!-- Dashboard (single) -->
        <v-list-item
          to="/perfil"
          color="#006fc9"
          active-class="is-active"
          class="rounded-lg mx-2 my-1"
        >
          <span class="nav-symbol"><i class="fas fa-th-large" aria-hidden="true"></i></span>
          <v-list-item-title class="font-600">Dashboard</v-list-item-title>
        </v-list-item>

        <!-- Groups -->
        <v-list-group
          v-for="grp in filteredMenu"
          :key="grp.title"
          no-action
          class="rounded-lg mx-2 my-1"
        >
          <template v-slot:activator>
            <span class="nav-symbol"><i :class="grp.title === 'Reportes' ? 'fas fa-chart-bar' : 'fas fa-layer-group'" aria-hidden="true"></i></span>
            <v-list-item-content>
              <v-list-item-title class="font-600">{{ grp.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="child in grp.items"
            :key="child.title"
            :to="child.link"
            :disabled="child.aproved"
            active-class="is-active"
            class="rounded-lg my-1"
          >
            <span class="nav-symbol child-symbol"><i class="fas fa-angle-right" aria-hidden="true"></i></span>
            <v-list-item-content>
              <v-list-item-title>{{ child.title }}</v-list-item-title>
            </v-list-item-content>
            <v-chip v-if="child.aproved" x-small class="chip-disabled" outlined>Pronto</v-chip>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <!-- TOP BAR -->
    <v-app-bar app flat height="80" class="ficenca-topbar ficenca-glass-shell">

      <v-btn icon text color="white" class="ficenca-menu-toggle" aria-label="Abrir menú" @click="nav = !nav">
        <i class="fas fa-bars"></i>
      </v-btn>

      <div class="pl-2 topbar-title">
        <div>Panel de control</div>
        <div class="topbar-subtitle">FICENCA · SERVICIOS</div>
      </div>

      <v-spacer />

      <!-- User menu -->
      <v-menu offset-y :close-on-click="true" content-class="ficenca-account-menu" transition="slide-y-transition" :nudge-bottom="10">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="ficenca-account-trigger" v-bind="attrs" v-on="on" aria-label="Menú de usuario">
            <v-avatar size="30">
              <img :src="usuario.pic || defaultAvatar" @error="onAvatarError" alt="avatar" />
            </v-avatar>
            <span class="ficenca-account-label d-none d-sm-flex"><strong>{{ usuario.username || 'Mi cuenta' }}</strong><small>{{ usuario.cargo || 'Usuario' }}</small></span>
            <i class="fas fa-chevron-down ficenca-account-chevron" aria-hidden="true"></i>
          </v-btn>
        </template>

        <v-list dense class="ficenca-account-list">
          <v-list-item class="ficenca-account-header">
            <v-list-item-avatar size="48">
              <img :src="usuario.pic || defaultAvatar" @error="onAvatarError" alt="" />
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="ficenca-account-eyebrow">MI CUENTA</div>
              <v-list-item-title class="font-weight-bold">{{ usuario.username || 'Usuario' }}</v-list-item-title>
              <v-list-item-subtitle class="text-truncate">{{ usuario.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <div class="ficenca-account-options">
            <v-list-item class="ficenca-account-option" @click="irAMiPerfil">
              <v-list-item-icon class="mr-3"><i class="fas fa-user" aria-hidden="true"></i></v-list-item-icon>
              <v-list-item-title>Mi perfil</v-list-item-title>
              <i class="fas fa-chevron-right ficenca-option-arrow" aria-hidden="true"></i>
            </v-list-item>
            <v-list-item class="ficenca-account-option" @click="openMarcas">
              <v-list-item-icon class="mr-3"><i class="fas fa-wrench" aria-hidden="true"></i></v-list-item-icon>
              <v-list-item-title>Marcas</v-list-item-title>
              <i class="fas fa-chevron-right ficenca-option-arrow" aria-hidden="true"></i>
            </v-list-item>
            <v-divider />
            <v-list-item class="ficenca-account-option ficenca-account-exit" @click="signOut">
              <v-list-item-icon class="mr-3"><i class="fas fa-sign-out-alt" aria-hidden="true"></i></v-list-item-icon>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item>
          </div>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- ✅ MODAL MARCAS -->
    <v-dialog
      v-model="marcasDialog"
      max-width="640"
      :fullscreen="isMobile"
      transition="dialog-bottom-transition"
      overlay-opacity="0.4"
    >
      <v-card class="modal-ios">
        <!-- Header -->
        <div class="modal-header">
          <div class="modal-actions">
  <v-btn
    v-if="puedeCrearMarca"
    small
    class="btn-primary-ios mr-2"
    @click="openNuevaMarca"
  >
    <i class="fas fa-plus mr-1"></i>
    Nueva marca
  </v-btn>
</div>

          <div class="modal-title">
            <div class="modal-title__top">Marcas</div>
            <div class="modal-title__sub">Compresores registrados</div>
          </div>

          <div class="modal-actions">
            <v-btn icon class="btn-icon" @click="marcasDialog = false" aria-label="Cerrar">
              <i class="fas fa-times"></i>
            </v-btn>
          </div>
        </div>

        <!-- Search -->
        <div class="modal-search px-4 pb-2">
          <div class="search">
            <i class="fas fa-search search-icon"></i>
            <input
              v-model.trim="marcasQ"
              class="search-input"
              type="text"
              placeholder="Buscar marca…"
            />
          </div>
        </div>

        <!-- Body -->
        <div class="px-4 pb-4">
          <!-- Loading -->
          <div v-if="marcasLoading">
            <v-skeleton-loader type="list-item-avatar-two-line" class="mb-2" />
            <v-skeleton-loader type="list-item-avatar-two-line" class="mb-2" />
            <v-skeleton-loader type="list-item-avatar-two-line" class="mb-2" />
          </div>

          <!-- Error -->
          <v-alert v-else-if="marcasError" type="error" dense text class="rounded-lg">
            {{ marcasError }}
          </v-alert>

          <!-- List -->
          <div v-else class="ios-list">
            <div class="ios-list__meta">
              <span>{{ marcasFiltradas.length }} marca(s)</span>
              <span class="dot">•</span>
              <span>Actualizado: {{ marcasLastUpdate || '—' }}</span>
            </div>

            <v-list dense class="ios-list__card">
              <v-list-item
                v-for="m in marcasFiltradas"
                :key="m.id"
                class="ios-list-item"
              >
                <v-list-item-avatar size="38" class="avatar-ios">
                  <div class="avatar-ios__inner">
                    {{ (m.nombre || '').slice(0, 1) }}
                  </div>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="brand-name">
                    {{ m.nombre }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-chip x-small outlined class="pill">
                  {{ m.compresores }} {{ m.compresores === 1 ? 'compresor' : 'compresores' }}
                </v-chip>
              </v-list-item>

              <v-list-item v-if="!marcasFiltradas.length" class="ios-empty">
                <v-list-item-content>
                  <v-list-item-title>No hay marcas</v-list-item-title>
                  <v-list-item-subtitle>Intenta con otro término de búsqueda.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="nuevaMarcaDialog" max-width="420">
  <v-card class="modal-ios">
    <div class="modal-header">
      <div class="modal-title__top">Nueva marca</div>
      <v-btn icon class="btn-icon" @click="nuevaMarcaDialog = false">
        <i class="fas fa-times"></i>
      </v-btn>
    </div>

    <div class="px-4 pb-4">
      <v-text-field
        v-model="nuevaMarcaNombre"
        label="Nombre de la marca"
        outlined
        dense
        autofocus
      />

      <v-alert v-if="nuevaMarcaError" type="error" dense text>
        {{ nuevaMarcaError }}
      </v-alert>

      <v-btn
        block
        class="btn-primary-ios mt-3"
        :loading="nuevaMarcaLoading"
        @click="guardarMarca"
      >
        Guardar marca
      </v-btn>
    </div>
  </v-card>
</v-dialog>


  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";

export default {
  data: () => ({
    nuevaMarcaDialog: false,
    nuevaMarcaNombre: '',
    nuevaMarcaLoading: false,
    nuevaMarcaError: '',
    nav: true,
    mini: false,
    q: "",
    defaultAvatar:
      "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg",

    // ✅ modal marcas
    marcasDialog: false,
    marcas: [],
    marcasLoading: false,
    marcasError: "",
    marcasQ: "",
    marcasLastUpdate: "",

    // ✅ ajusta esta URL si tu endpoint está en otra ruta
    apiBase: "https://apps.grupoficenca.com/php/api.php",

    menu: [
      {
        title: "Reportes",
        items: [
          { title: "Historial de trabajos finalizados", link: "/trabajos-finalizados", aproved: false },
          { title: "Historial toma de horas", link: "/reporte/toma-de-horas", aproved: false },
        ],
      },
      {
        title: "Clientes y Equipos",
        items: [
          { title: "Clientes", link: "/clientes", aproved: false },
          { title: "Solicitantes", link: "/solicitantes", aproved: false },
          { title: "Equipos", link: "/lista-equipos", aproved: false },
        ],
      },
    ],
  }),
  computed: {
    ...mapState(["usuario"]),
    isMobile() {
      return this.$vuetify && this.$vuetify.breakpoint.smAndDown;
    },
    puedeCrearMarca() {
    if (!this.usuario) return false;
    const rol = (this.usuario.rol || this.usuario.cargo || '').toLowerCase();
    return rol === 'manager' || rol === 'administrativo' || rol === 'developer';
  },
    filteredMenu() {
      const term = (this.q || "").toLowerCase();
      if (!term) return this.menu;
      return this.menu
        .map((g) => ({
          ...g,
          items: g.items.filter((c) => c.title.toLowerCase().includes(term)),
        }))
        .filter((g) => g.items.length);
    },

    // ✅ filtro para el modal
    marcasFiltradas() {
      const t = (this.marcasQ || "").toLowerCase();
      if (!t) return this.marcas;
      return this.marcas.filter((m) => (m.nombre || "").toLowerCase().includes(t));
    },
  },
  methods: {
    ...mapActions(["signOut"]),

    openNuevaMarca() {
    this.nuevaMarcaNombre = '';
    this.nuevaMarcaError = '';
    this.nuevaMarcaDialog = true;
  },

  async guardarMarca() {
    if (!this.nuevaMarcaNombre.trim()) {
      this.nuevaMarcaError = 'El nombre es obligatorio';
      return;
    }

    this.nuevaMarcaLoading = true;
    this.nuevaMarcaError = '';

    try {
      const { data } = await axios.post(
      `${this.apiBase}?action=crearMarca`,
      {
        nombre: this.nuevaMarcaNombre,
        requester_cargo: this.usuario?.cargo || ''
      }
    );


      if (data.status !== 'success') {
        this.nuevaMarcaError = data.message || 'Error al crear la marca';
        return;
      }

      this.nuevaMarcaDialog = false;
      await this.fetchMarcas(); // recargar lista
    } catch (e) {
      this.nuevaMarcaError = 'Error de conexión';
    } finally {
      this.nuevaMarcaLoading = false;
    }
  },

    onAvatarError(e) {
      e.target.src = this.defaultAvatar;
    },

    irAMiPerfil() {
      window.open("/perfil", "_self");
    },

    // ✅ abrir modal + cargar datos
    async openMarcas() {
      this.marcasDialog = true;
      await this.fetchMarcas();
    },

    async fetchMarcas() {
  this.marcasLoading = true;
  this.marcasError = "";

  try {
    const url = `${this.apiBase}?action=getMarcasPerfil&_=${Date.now()}`; // cache buster ✅
    const { data } = await axios.get(url);

    // ✅ Si el backend responde error tipo {status:'error', message:'...'}
    if (data && typeof data === "object" && !Array.isArray(data) && data.status === "error") {
      this.marcas = [];
      this.marcasError = data.message || "El API devolvió un error.";
      this.marcasLastUpdate = new Date().toLocaleString();
      return;
    }

    // ✅ Si devuelve array directo (ideal)
    const arr = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    // Si no vino nada, muéstralo como error (para no “silenciarlo”)
    if (!arr.length) {
      this.marcas = [];
      this.marcasError = "El API devolvió 0 marcas. Revisa que getMarcasPerfil esté retornando data.";
      this.marcasLastUpdate = new Date().toLocaleString();
      return;
    }

    this.marcas = arr.map((x) => ({
      id: x.id,
      uid: x.uid,
      nombre: (x.nombre || "").toUpperCase(),
      creado_en: x.creado_en,
      compresores: Number(x.compresores || 0),
    }));

    this.marcasLastUpdate = new Date().toLocaleString();
  } catch (e) {
    this.marcasError =
      (e?.response?.data?.message) ||
      e?.message ||
      "No se pudieron cargar las marcas.";
  } finally {
    this.marcasLoading = false;
  }
}
,

    formatFecha(dt) {
      if (!dt) return "—";
      // dt viene tipo: 2025-04-24 13:55:46
      const s = String(dt).replace(" ", "T");
      const d = new Date(s);
      if (isNaN(d.getTime())) return dt;
      return d.toLocaleDateString();
    },
  },
};
</script>

<style scoped>

/* =========================
   iOS Floating Drawer (MENU)
   ========================= */

/* Drawer flotante */
.ios-float-drawer {
  /* separarlo de los bordes para que se vea “flotando” */
  margin: 14px !important;
  height: calc(100% - 28px) !important;

  border-radius: 22px !important;
  overflow: hidden !important;

  /* glass */
  background: rgba(255, 255, 255, 0.82) !important;
  backdrop-filter:none !important;
  -webkit-backdrop-filter:none !important;

  border: 1px solid rgba(0, 0, 0, 0.06) !important;

  /* sombra iOS */
  box-shadow:
    0 24px 70px rgba(0, 0, 0, 0.25),
    0 6px 18px rgba(0, 0, 0, 0.10) !important;
}

/* Quitar el “fondo” clásico del drawer */
.ios-float-drawer .v-navigation-drawer__content {
  background: transparent !important;
  padding-bottom: 10px;
}

/* Para que el drawer se vea mejor en desktop */
@media (min-width: 960px) {
  .ios-float-drawer {
    margin: 16px 10px 16px 16px !important;
  }
}

/* En móvil: sigue siendo flotante pero más pegado */
@media (max-width: 600px) {
  .ios-float-drawer {
    margin: 10px !important;
    height: calc(100% - 20px) !important;
    border-radius: 20px !important;
  }
}

/* =========================
   Topbar glass (iOS)
   ========================= */

.ios-topbar-glass {
  /* glass over gradient */
  background: rgba(10, 132, 255, 0.85) !important;
  backdrop-filter:none !important;
  -webkit-backdrop-filter:none !important;
  border-bottom: 1px solid rgba(255,255,255,0.18) !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.18);
}

/* Botones topbar más “pill” */
.ios-topbar-glass .v-btn {
  border-radius: 14px !important;
}

/* =========================
   Ajustes finos para look premium
   ========================= */

/* Bloque usuario más limpio y flotante */
.user-block {
  background: rgba(255,255,255,0.60) !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  box-shadow: 0 10px 24px rgba(0,0,0,0.08);
}

/* List items como pills */
.v-list-item.rounded-lg {
  border-radius: 14px !important;
  border: 1px solid rgba(0,0,0,0.05);
  background: rgba(255,255,255,0.60);
}

/* Hover más suave */
.v-list-item.rounded-lg:hover {
  transform: translateY(-1px);
  background: rgba(10, 132, 255, 0.08);
}

/* Active route más iOS */
.is-active {
  border-left: 0 !important;
  background: rgba(10, 132, 255, 0.14) !important;
  box-shadow: inset 0 0 0 1px rgba(10,132,255,0.22);
}

/* Barra de búsqueda más iOS */
.search-input {
  background: rgba(255,255,255,0.75);
}

/* Chips más finos */
.role-chip,
.chip-disabled,
.pill {
  border-radius: 999px !important;
}


  .btn-primary-ios {
    letter-spacing: 0 !important;
    text-transform: none;
  background: linear-gradient(90deg, #006fc9, #0a84ff);
  color: #fff !important;
  border-radius: 12px;
  font-weight: 600;
}

/* Active route marker */
.is-active {
  border-left: 5px solid #0a84ff !important;
  background: rgba(10, 132, 255, 0.08) !important;
}
</style>

<style scoped>
/* iOS-like card */
.ios-card {
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  border-radius: 16px !important;
}

/* Drawer */
.side-drawer {
  display: flex;
  flex-direction: column;
}

/* User block */
.user-block {
  margin: 0 12px 12px;
  padding: 10px 12px;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  background: #fafafa;
}
.role-chip {
  margin-left: 8px;
  border-color: #e5e7eb !important;
  color: #0b1220 !important;
}

/* Search */
.search {
  position: relative;
}
.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.6;
}
.search-input {
  width: 100%;
  height: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 8px 12px 8px 36px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.search-input:focus {
  border-color: #0a84ff;
  box-shadow: 0 0 0 4px rgba(10, 132, 255, 0.12);
}

/* Topbar */
.topbar {
  background: linear-gradient(90deg, #006fc9, #0a84ff) !important;
  color: #fff !important;
}
.topbar-title {
  font-weight: 800;
  letter-spacing: -0.2px;
}

/* Chips */
.chip-disabled {
  border-color: #e0e0e0 !important;
  color: #8a8a8a !important;
}

/* Typography helpers */
.font-600 {
  font-weight: 600;
}

/* List item hover */
.v-list-item.rounded-lg {
  transition: background 0.15s, transform 0.15s;
}
.v-list-item.rounded-lg:hover {
  background: rgba(10, 132, 255, 0.06);
}

/* ✅ MODAL iOS */
.modal-ios {
  border-radius: 18px !important;
  border: 1px solid rgba(0,0,0,.06) !important;
  box-shadow: 0 20px 60px rgba(0,0,0,.22);
  overflow: hidden;
  background: rgba(255,255,255,.92);
  backdrop-filter:none !important;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px 10px 16px;
  border-bottom: 1px solid rgba(0,0,0,.06);
}
.modal-title__top {
  font-weight: 900;
  letter-spacing: -0.2px;
  font-size: 18px;
  color: #0b1220;
}
.modal-title__sub {
  margin-top: 2px;
  font-size: 12.5px;
  color: rgba(11,18,32,.6);
}
.btn-icon {
  background: rgba(10,132,255,.08) !important;
  border: 1px solid rgba(10,132,255,.18) !important;
  border-radius: 12px !important;
}

/* List area */
.ios-list__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(11,18,32,.6);
  font-size: 12px;
  margin: 6px 2px 10px 2px;
}
.dot { opacity: .6; }

.ios-list__card {
  background: rgba(245,247,251,.9);
  border: 1px solid rgba(0,0,0,.06);
  border-radius: 14px;
  padding: 6px;
}
.ios-list-item {
  border-radius: 12px;
  margin: 6px 0;
  background: rgba(255,255,255,.85);
  border: 1px solid rgba(0,0,0,.05);
}
.avatar-ios {
  background: transparent !important;
}
.avatar-ios__inner {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-weight: 900;
  color: #0a84ff;
  background: rgba(10,132,255,.10);
  border: 1px solid rgba(10,132,255,.18);
  text-transform: uppercase;
}
.brand-name {
  font-weight: 800;
  letter-spacing: -.2px;
}
.brand-sub {
  font-size: 12px;
  color: rgba(11,18,32,.55);
}
.pill {
  border-color: rgba(10,132,255,.25) !important;
  color: rgba(11,18,32,.75) !important;
  background: rgba(10,132,255,.06) !important;
}
.ios-empty {
  background: transparent !important;
  border: 0 !important;
}

/* Responsive */
@media (max-width: 600px) {
  .topbar-title {
    font-size: 14.5px;
  }
}
</style>

<style>
.ficenca-account-menu { border:1px solid #e0e9f3; border-radius:18px !important; background:#ffffff; box-shadow:0 16px 42px rgba(19,91,160,.16) !important; min-width:285px; max-width:calc(100vw - 24px) !important; overflow:hidden; }
.ficenca-account-menu > .v-list { padding:8px; }
.ficenca-account-menu .v-list-item:first-child { padding:14px 12px; background:#f3f8fd; border-radius:12px; margin-bottom:8px; }
.ficenca-account-menu .v-list-item__title { color:#24374a; font-size:13px; }
.ficenca-account-menu .v-list-item__subtitle { color:#8190a3; font-size:11px; margin-top:3px; }
.ficenca-account-menu .v-list-item--link { margin:4px 0; padding:0 12px; min-height:46px; border-radius:11px; transition:background-color .18s; }
.ficenca-account-menu .v-list-item--link:hover { background:#edf6ff; }
.ficenca-account-menu .v-list-item__icon { width:30px; height:30px; margin-top:8px; margin-bottom:8px; display:flex; align-items:center; justify-content:center; border-radius:9px; background:#edf6ff; color:#135ba0; }
.ficenca-account-menu .v-list-item:last-child .v-list-item__icon { background:#fff2f3; color:#b44755; }
.ficenca-account-menu .v-divider { border-color:#edf1f6; margin:7px 4px; }
.ficenca-account-menu .v-list-item--link i { transition:transform .18s; }
.ficenca-account-menu .v-list-item--link:hover i { transform:translateX(2px); }
.ficenca-app .ficenca-topbar { padding-left:12px; padding-right:12px; }
.ficenca-app .ficenca-topbar .ficenca-menu-toggle { width:38px; height:38px; border:1px solid rgba(255,255,255,.2); background:rgba(255,255,255,.09); border-radius:11px !important; margin-right:10px; }
.ficenca-app .ficenca-topbar .ficenca-account-trigger { padding:6px 10px !important; min-height:46px; border-radius:13px !important; border:1px solid rgba(255,255,255,.2); color:#ffffff; background:rgba(255,255,255,.08); }
.ficenca-account-label { flex-direction:column; align-items:flex-start; margin:0 14px 0 10px; line-height:1.5; max-width:180px; }
.ficenca-account-label strong { font-size:11px; font-weight:600; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:100%; }
.ficenca-account-label small { font-size:10px; opacity:.75; font-weight:400; }
.ficenca-account-chevron { font-size:10px; margin-left:6px; opacity:.8; transition:transform .18s; }
.ficenca-account-trigger[aria-expanded="true"] .ficenca-account-chevron { transform:rotate(180deg); }
@media(max-width:600px) { .ficenca-app .ficenca-topbar { padding-left:6px; padding-right:6px; } .ficenca-app .ficenca-topbar .topbar-title { font-size:13px; } }
@media(prefers-reduced-motion:reduce) { .ficenca-account-menu .v-list-item--link,.ficenca-account-menu i,.ficenca-account-chevron { transition:none !important; transform:none !important; } }
</style>

<style>
/* La superficie interior flota dentro del espacio reservado por Vuetify. */
.ficenca-app .ficenca-topbar.v-app-bar { background:transparent !important; box-shadow:none !important; border:0 !important; padding:0 !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }
.ficenca-app .ficenca-topbar > .v-toolbar__content { height:60px !important; margin:10px 14px; padding:0 14px; border-radius:17px; background:linear-gradient(115deg,#135ba0,#0273d5); border:1px solid rgba(255,255,255,.3); box-shadow:0 7px 20px rgba(19,91,160,.18),inset 0 1px 0 rgba(255,255,255,.1); }
.ficenca-app .ficenca-topbar .ficenca-menu-toggle { border-radius:11px !important; }
.ficenca-app .ficenca-topbar .ficenca-account-trigger { background:rgba(255,255,255,.1); border-color:rgba(255,255,255,.23); }
@media(max-width:600px) { .ficenca-app .ficenca-topbar > .v-toolbar__content { margin:10px 8px; padding:0 9px; border-radius:15px; } .ficenca-app .ficenca-topbar .ficenca-menu-toggle { margin-right:5px; } }
</style>

<style>
/* El marco exterior no debe pintar un segundo rectángulo azul. */
#app .v-application.ficenca-app .ficenca-glass-shell.v-app-bar { background:none !important; background-color:transparent !important; background-image:none !important; border:0 !important; box-shadow:none !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }
#app .ficenca-glass-shell > .v-toolbar__content { border-radius:17px; overflow:hidden; background:rgba(19,91,160,.94); border:1px solid rgba(255,255,255,.42); box-shadow:0 6px 20px rgba(19,61,105,.14),inset 0 1px 0 rgba(255,255,255,.2); }
#app .ficenca-glass-shell .topbar-title { color:#ffffff; font-size:15px; font-weight:600; }
#app .ficenca-glass-shell .topbar-subtitle { font-size:10px; letter-spacing:.8px; opacity:.8; font-weight:400; }
@media(prefers-reduced-transparency:reduce) { #app .ficenca-glass-shell > .v-toolbar__content { background:#135ba0; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; } }
</style>

<style>
#app .ficenca-glass-shell > .v-toolbar__content { background:linear-gradient(115deg,#135ba0,#0273d5) !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }
#app .v-application.ficenca-app .ficenca-glass-shell.v-app-bar { background:transparent !important; background-image:none !important; }
.ficenca-account-menu { background:#ffffff !important; backdrop-filter:none !important; -webkit-backdrop-filter:none !important; }
</style>

<style>
#app .ficenca-glass-shell .topbar-title,
#app .ficenca-glass-shell .topbar-title > div,
#app .ficenca-glass-shell .topbar-subtitle,
#app .ficenca-glass-shell .ficenca-menu-toggle,
#app .ficenca-glass-shell .ficenca-menu-toggle i,
#app .ficenca-glass-shell .ficenca-account-trigger,
#app .ficenca-glass-shell .ficenca-account-label strong,
#app .ficenca-glass-shell .ficenca-account-label small,
#app .ficenca-glass-shell .ficenca-account-chevron { color:#ffffff !important; opacity:1; }
</style>

<style>
.ficenca-account-menu { width:320px; min-width:0; border:1px solid #e0e9f3 !important; border-radius:20px !important; box-shadow:0 18px 48px rgba(19,65,110,.2) !important; }
.ficenca-account-menu > .ficenca-account-list { padding:0; background:#fff !important; }
.ficenca-account-menu .ficenca-account-header:first-child { margin:0; padding:20px 18px; border-radius:0; background:linear-gradient(115deg,#135ba0,#0273d5); }
.ficenca-account-header .v-avatar { border:2px solid rgba(255,255,255,.7); box-shadow:0 3px 10px rgba(0,30,70,.15); }
.ficenca-account-menu .ficenca-account-header .v-list-item__title { color:#fff; font-size:14px; line-height:1.5; }
.ficenca-account-menu .ficenca-account-header .v-list-item__subtitle { color:#e4f1ff; font-size:12px; margin-top:4px; }
.ficenca-account-eyebrow { color:#cde2f6; font-size:9px; font-weight:700; letter-spacing:1.4px; margin-bottom:5px; }
.ficenca-account-options { padding:10px; }
.ficenca-account-menu .ficenca-account-option.v-list-item { min-height:52px; padding:0 10px; margin:3px 0; border-radius:12px; background:transparent; transition:background-color .2s,transform .2s; }
.ficenca-account-menu .ficenca-account-option .v-list-item__title { font-size:13px; font-weight:600; }
.ficenca-account-menu .ficenca-account-option .v-list-item__icon { width:34px; height:34px; border-radius:10px; margin-top:9px; margin-bottom:9px; background:#edf6ff; color:#135ba0; }
.ficenca-option-arrow { font-size:10px; color:#8aaccb; margin-left:12px; }
.ficenca-account-menu .ficenca-account-option:hover { background:#edf6ff; transform:translateX(2px); }
.ficenca-account-menu .ficenca-account-option:focus-visible { outline:2px solid #0273d5; outline-offset:-2px; }
.ficenca-account-menu .ficenca-account-exit .v-list-item__title { color:#bd4056; }
.ficenca-account-menu .ficenca-account-exit .v-list-item__icon { color:#bd4056; background:#fff0f3; }
.ficenca-account-menu .ficenca-account-exit:hover { background:#fff4f6; }
.ficenca-account-menu .v-divider { margin:10px 8px; }
@media(prefers-reduced-motion:reduce) { .ficenca-account-menu .ficenca-account-option.v-list-item { transition:none; transform:none; } }
</style>
